// It wasn't possible to import ONLY the version number from package.json and it
// would be a security risk to include the entire package.json file in the webpacked
// bundle. Please ensure the version is updated in both places.
export const SCRIPT_VERSION = '3.0.0';

export const ZAPIER_API_V4_URL = 'https://zapier.com/api/v4';
export const ZAPIER_API_V4_URL_STAGING = 'https://zapier-staging.com/api/v4';
